import { Tabs } from "@material-ui/core";
import React, { Fragment } from "react";
import { PaddedFlexBox } from "../../../ui/Flex";
import {
  DropdownContainer,
  StyledTab,
  StyledTooltip,
} from "../../SchoolProfileView.styled";
import { MeterDropdown } from "../MeterDropdown/MeterDropdown";
import { LiveViewTooltip } from "./LiveViewTooltip";
import { MeterBreakdownTooltip } from "./MeterBreakdownTooltip";

export const GraphHeader = ({
  setSelectedSubMeterIndex,
  setSelectedGridVMIndex,
  setSelectedMeterIndex,
  selectedSubMeterIndex,
  setSelectedDataIndex,
  selectedGridVMIndex,
  selectedMeterIndex,
  selectedDataIndex,
  physicalMeters,
  resourceType,
  setGraphTab,
  subMeters,
  graphTab,
  gridVMs,
  user,
  tabs,
  api,
}) => (
  <Fragment>
    <Tabs
      value={graphTab}
      onChange={(_, val) => setGraphTab(val)}
      style={{ marginBottom: "0.5rem" }}
      indicatorColor="primary"
    >
      <StyledTab label="Energy Graph" />
      <StyledTab
        style={{ pointerEvents: "auto" }}
        disabled={!physicalMeters.length || !user || !user.featureAccess.includes("Live Meter Data")}
        label={
          <LiveViewTooltip
            user={typeof user !== "undefined" && user}
            resourceType={resourceType}
            WWMeters={physicalMeters}
            api={api}
          >
            <span>Live View</span>
          </LiveViewTooltip>
        }
      />
      {gridVMs.length > 1 ? (
        <StyledTab
          label={
            <MeterBreakdownTooltip
              user={typeof user !== "undefined" && user}
              resourceType={resourceType}
              gridVMs={gridVMs}
              api={api}
            >
              <span>Meter Breakdown</span>
            </MeterBreakdownTooltip>
          }
          style={{ pointerEvents: "auto" }}
          disabled={
            (resourceType !== "sites" && typeof user === "undefined") || !user
          }
        />
      ) : null}
    </Tabs>
    <PaddedFlexBox>
      {graphTab === tabs.DEFAULT && subMeters.length ? (
        <DropdownContainer>
          <MeterDropdown
            selected={selectedDataIndex}
            meters={subMeters}
            callback={(val) => setSelectedDataIndex(val)}
            additionalOption="Total Energy"
          />
        </DropdownContainer>
      ) : null}
      {graphTab === tabs.SUBMETERS && subMeters.length ? (
        <DropdownContainer>
          <MeterDropdown
            selected={selectedSubMeterIndex}
            meters={subMeters}
            callback={(val) => setSelectedSubMeterIndex(val)}
          />
        </DropdownContainer>
      ) : null}
      {graphTab === tabs.LIVE && physicalMeters.length ? (
        <DropdownContainer>
          <MeterDropdown
            selected={selectedMeterIndex}
            meters={physicalMeters}
            callback={(val) => setSelectedMeterIndex(val)}
          />
        </DropdownContainer>
      ) : null}
      {graphTab === tabs.GRIDVMS && gridVMs.length > 1 ? (
        <DropdownContainer>
          <MeterDropdown
            selected={selectedGridVMIndex}
            meters={gridVMs}
            callback={(val) => setSelectedGridVMIndex(val)}
          />
        </DropdownContainer>
      ) : null}
    </PaddedFlexBox>
  </Fragment>
);



// WEBPACK FOOTER //
// ./resources/assets/js/app/SchoolProfileView/components/GraphHeader/GraphHeader.js